import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import PostingsApi from '../../../API/shipment/postings-api';
import ShipmentsApi from '../../../API/shipment/shipments-api';
import delete_img from '../../../assets/media/bucket.svg';
import icon_update from '../../../assets/media/icon-updated.png';
import close from '../../../assets/media/icons/close.svg';
import stickers_load from '../../../assets/media/stickers_load.png';
import { Column, NavTabs, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button, ButtonWithTooltip, CheckButton } from '../../../components/Basic/Buttons';
import { Icon } from '../../../components/Basic/Elements';
import { Content } from '../../../components/Basic/Global';
import { DateInput, InputLabel, Select } from '../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableCell, TableHeader, TableLine } from '../../../components/Basic/Table';
import { H1 } from '../../../components/Basic/WrapsStyle';
import { SHIPMENT_STATUS_TEXT, STATUS_COLORS, TO_STATISTIC_SHIPMENT, TYPE_BUTTONS, WAREHOUSE_LIST } from '../../../constans';
import { getDate } from '../../../utils';
import CreateShipmentPopUp from './CreateShipmentPopUp';
import DeleteShipmentPopUp from './DeleteShipmentPopUp';
import styles from './styles.module.scss';

const width = ['40px', '140px', '150px', '200px', '90px'];

const SKLAD_LIST = [{ warehouse: 'Не выбран', name: undefined }, ...WAREHOUSE_LIST];
const FILTER = {
  0: '',
  1: 'ozon',
  2: 'wb',
  3: 'yandex',
  4: 'megamarket',
};

const MAP_SKLAD = {
  msk: 'Москва',
  ekb: 'Екатеринбург',
};
const MARKET_NAME = {
  ozon: 'Ozon',
  yandex: 'Yandex',
  wb: 'Wb',
  megamarket: 'Megamarket',
  avito: 'Avito',
  Ozon: 'Ozon',
  Yandex: 'Yandex',
  Wb: 'Wb',
  Sber: 'Megamarket',
};

function ShipmentStatisticFboPage() {
  const [create, setCreate] = useState(false);
  const [popUpDelete, setDeletePopUp] = useState({ show: false, shipment: {} });
  const [address, changeAddress] = useState('');
  const [skladName, setSkladName] = useState(SKLAD_LIST[0]);
  const [count, setCount] = useState([0, 0, 0, 0, 0]);
  const [tab, setTab] = useState(0);
  const [show, setShow] = useState(50);
  const [date, setDate] = useState(null);
  const [financesStatisticMap, setFinancesStatisticMap] = useState({})

  const [shipments, setShipments] = useState([]);
  const [shipmentsSelect, setShipmentsSelect] = useState({});
  const user = useSelector((store) => store.user);

  const onClickCreate = () => {
    setCreate(true);
  };

  const changeShipmentsSelect = (number) => {
    if (shipmentsSelect[number]) {
      const s = shipmentsSelect;
      delete s[number];
      setShipmentsSelect({ ...s });
    } else {
      setShipmentsSelect({ ...shipmentsSelect, [number]: true });
    }
  };

  const openManyShipments = () => { };
  const loadShipments = () => {
    const isExpress = tab === 0 ? undefined : tab === 5;
    ShipmentsApi.getShipments({ data: { saleSchema: 'fbo', market: FILTER[tab], limit: parseInt(show), isExpress, skladName: skladName.name, shipmentDate: date, getFinances: true } }).then((r) => {
      setShipments(r.shipments)
      setFinancesStatisticMap(r.finances)
    })

  };

  const onChangeTab = (n) => {
    setTab(n);
  };

  const onCloseDelete = () => {
    setDeletePopUp({ show: false, shipment: {} });
    loadShipments();
  };

  useEffect(() => {
    loadShipments();
  }, [tab, show, skladName.name, date]);

  const shipmetns_ids = Object.keys(shipmentsSelect);

  const isOwner = user.role === 'owner' || user.role === 'admin';

  return (
    <>
      <Content>
        <H1>Статистика по отгрузкам FBO</H1>

        <WhiteBlock className={styles.search_block}>
          <Row className={styles.navigate_table}>
            <NavTabs
              open_tab={tab}
              tabs={['Все отгрузки', 'Ozon', 'Wildberries', 'ЯндексМаркет', 'Мегамаркет', 'Экспрессы']}
              num={count}
              style_tab={styles.style_tab}
              onChange={onChangeTab}
            />
          </Row>
          <Row spaceBetween={true} style={{ marginTop: '25px' }}>
            <Row style={{ height: '40px' }}>
              <Select
                label="Показать на странице"
                select={show}
                list={['10', '20', '50', '100', '150', '200', '500', '1000']}
                onSelect={(v) => setShow(v)}
                width="150px"
                style={{ marginRight: '15px' }}
              />
              {(isOwner || user.role === 'booker') && (
                <Select
                  label="Город"
                  select={skladName}
                  list={SKLAD_LIST}
                  valueFn={(p) => p.warehouse}
                  onSelect={(v) => setSkladName(v)}
                  width="200px"
                  style={{ marginRight: '15px' }}
                />
              )}
              <Column style={{ marginRight: '15px' }}>
                <InputLabel>Дата отгрузки</InputLabel>
                <Row style={{ position: 'relative', width: '150px' }}>
                  <DateInput value={date} className={styles.calendar} onChange={(v) => setDate(v)} />
                  <Button className={styles.close_button} onClick={() => setDate(null)}>
                    <img src={close} style={{ width: '15px' }} />
                  </Button>
                </Row>
              </Column>
              {shipmetns_ids.length > 1 && shipmetns_ids.length <= 6 && (
                <a href={TO_STATISTIC_SHIPMENT(shipmetns_ids.join('&'))} target={'_blank'} style={{ marginLeft: '10px' }}>
                  <Button type={TYPE_BUTTONS.BLUE} onClick={openManyShipments}>
                    Начать совместную отгрузку
                  </Button>
                </a>
              )}
            </Row>
            {/*  <Column className={styles.column_button}></Column>*/}
          </Row>
        </WhiteBlock>
        <Table>
          <TableHeader whiteHeader>
            <HeaderTitle width={width[0]} />
            <HeaderTitle width={width[0]}>Id</HeaderTitle>
            <HeaderTitle width={width[1]}>Площадка</HeaderTitle>
            <HeaderTitle width={width[2]} centerText>Дата отгрузки</HeaderTitle>
            <HeaderTitle width={width[2]} centerText>Количество заказов</HeaderTitle>
            <HeaderTitle width={width[2]} centerText>Статус</HeaderTitle>
            <HeaderTitle width={width[2]} centerText>Склад</HeaderTitle>
            <HeaderTitle width={width[4]} centerText>Продажа</HeaderTitle>
            <HeaderTitle width={width[4]} centerText>Профит</HeaderTitle>
            <HeaderTitle width={width[4]} centerText>Комиссия</HeaderTitle>
            <HeaderTitle width={width[3]} centerText>
              Создатель
            </HeaderTitle>
          </TableHeader>
          {(shipments || []).map((shipment) => {
            return (
              <TableLine key={shipment.id}>
                <TableCell width={width[0]}>
                  <CheckButton
                    checked={shipmentsSelect[shipment.id]}
                    onSelect={() => changeShipmentsSelect(shipment.id)}
                  //disabled={is_disabled_print}
                  />
                </TableCell>
                <TableCell width={width[0]}>{shipment.id}</TableCell>
                <TableCell width={width[1]}>
                  <NavLink to={TO_STATISTIC_SHIPMENT(shipment.id)} className={styles.line_table_link}>
                    {MARKET_NAME[shipment.market]} {shipment.is_express && 'Express'}
                  </NavLink>
                </TableCell>
                <TableCell width={width[2]} center>
                  {getDate(shipment.time_scheduled)}
                </TableCell>
                <TableCell width={width[2]} center>
                  {shipment.num_postings}
                </TableCell>
                <TableCell width={width[2]} style={{ color: `${STATUS_COLORS[shipment.state]}` }} center>
                  {SHIPMENT_STATUS_TEXT[shipment.state]}
                </TableCell>
                <TableCell width={width[2]} center>
                  {MAP_SKLAD[shipment.sklad]}
                </TableCell>
                <TableCell width={width[4]} center>{Math.round(financesStatisticMap[shipment.id]?.price) || '-'}</TableCell>
                <TableCell width={width[4]} center>{Math.round(financesStatisticMap[shipment.id]?.profit) || '-'}</TableCell>
                <TableCell width={width[4]} center>{Math.round(financesStatisticMap[shipment.id]?.commissions) || '-'}</TableCell>
                <TableCell width={width[3]} center>
                  {shipment.creator}
                </TableCell>
                <TableCell width={width[0]} center>
                  <ButtonWithTooltip
                    tooltip="Выгрузить этикетки"
                    onClick={() => PostingsApi.loadStickers({ data: { shipmentId: shipment.id } })}
                  // disabled={shipment.state === 'ended'}
                  >
                    <Icon src={stickers_load} width={'30px'} />
                  </ButtonWithTooltip>
                </TableCell>
                <TableCell width={width[0]} center>
                  <ButtonWithTooltip tooltip="Обновить статусы" onClick={() => PostingsApi.updatePostingsStatus({ data: { shipmentId: shipment.id } })}>
                    <Icon src={icon_update} width={'30px'} />
                  </ButtonWithTooltip>
                </TableCell>
                <TableCell styles={styles.delete_cell}>
                  {isOwner && (
                    <ButtonWithTooltip
                      tooltip="Удалить"
                      onClick={() => setDeletePopUp({ show: true, shipment })}
                      disabled={shipment.state === 'ended' || shipment.state === 'started'}
                    >
                      <Icon src={delete_img} width={'20px'} />
                    </ButtonWithTooltip>
                  )}
                </TableCell>
              </TableLine>
            );
          })}
        </Table>
      </Content>
      {create && (
        <CreateShipmentPopUp
          close={() => {
            setCreate(false);
            loadShipments();
          }}
        />
      )}
      {popUpDelete.show && <DeleteShipmentPopUp shipment={popUpDelete.shipment} close={onCloseDelete} />}
    </>
  );
}

export default ShipmentStatisticFboPage;
